// extracted by mini-css-extract-plugin
export default {"centeredLoader":"aL0TDe5W","pageLoader":"Sdp9s2yP"};